document.addEventListener('DOMContentLoaded', () => {
  const openButton = document.querySelector('.js-related-content-open');
  const popup = document.querySelector('.js-related-content-popup');

  if (!openButton || !popup) return;

  const video = popup.querySelector('video');
  const closeButtons = popup.querySelectorAll('.js-related-content-close');

  const openPopup = () => {
    popup.classList.add('is-active');
    document.body.style.overflow = 'hidden';

    if (video) {
      video.play();
    }
  };

  const closePopup = () => {
    popup.classList.remove('is-active');
    document.body.style.overflow = '';

    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  };

  openButton.addEventListener('click', openPopup);

  closeButtons.forEach((button) => {
    button.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-active')) {
      closePopup();
    }
  });
});